// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"15cebb3a","481":"28e65e12","621":"6361af61"}[chunkId] + ".chunk.css";
};